import React, { useMemo } from 'react';
import { Chip } from "@curves/ui-base";
import usePrivacyToggle, { securityMaskFilterTypeMap } from '@util/hook/usePrivacyToggle';
import { PrivacyDataToggle } from '@icoach/components';
import Tablenization from '@icoach/components/Tablenization';

const setSendType = (sendType, sendText) => {
    let targetMap = {
        text: '失敗',
        color: 'error',
    };
    if (sendType < 0) {
        targetMap = {
            text: '預約',
            color: 'info',
        };
    } else if ([17, 18].includes(sendType)) {
        targetMap = {
            text: '成功',
            color: 'success',
        };
    } else if ([16].includes(sendType)) {
        targetMap = {
            text: sendText,
            color: 'info',
        };
    }
    return targetMap;
};

const SmsIdOverviewTable = React.forwardRef((props, ref) => {
    const { sourceData } = props;
    const { isRevealed, toggle, renderPrivacyIcon } = usePrivacyToggle();
    const rowsLabel = useMemo(
        () => [
            {
                cellKey: 'displayName',
                headerLabel: '姓名',
                width: 8,
                formatCell: (displayName, { maskDisplayName }, { isRevealed }) => {
                    return <PrivacyDataToggle fullData={displayName} maskedData={maskDisplayName} isRevealed={isRevealed} />;
                },
            },
            {
                cellKey: 'phone',
                headerLabel: '手機',
                width: 8,
                formatCell: (phone, { maskCellPhone }, { isRevealed }) => {
                    return <PrivacyDataToggle fullData={phone} maskedData={maskCellPhone} isRevealed={isRevealed} />;
                },
            },
            {
                cellKey: 'referenceTypeText',
                headerLabel: '對象',
                width: 8,
            },
            {
                cellKey: 'sendStatus',
                headerLabel: '狀態',
                align: 'center',
                width: 8,
                formatCell: (cellValue, { sendStatusText }) => {
                    const typeMap = setSendType(cellValue * 1, sendStatusText);
                    return <Chip color={typeMap.color} label={typeMap.text} />;
                },
            },
            {
                cellKey: 'sendStatusText',
                headerLabel: '備註',
                width: 14,
            },
        ],
        // eslint-disable-next-line
        [],
    );

    const handleToggleRevealed = () => {
        const apiParams = {
            filterType: securityMaskFilterTypeMap.ClubSmsOverview,
            totalCount: sourceData.totalCount,
        };
        toggle(apiParams);
    };

    return (
        <React.Fragment>
            {renderPrivacyIcon(handleToggleRevealed)}
            <Tablenization>
                <Tablenization.TableRowHeader headerRow={rowsLabel} />
                <Tablenization.TableRowBody headerRow={rowsLabel} rowsData={sourceData} isRevealed={isRevealed} />
            </Tablenization>
        </React.Fragment>
    );
});

export default SmsIdOverviewTable;
